export default "__VITE_ASSET__62ae1daf__"